import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconLlmSend = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg enableBackground="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="icon-llm-send" width="1em" height="1em" data-icon="icon-llm-send" aria-hidden="true" {...props} ref={ref}><path clipRule="evenodd" d="m3.8.2c-.3-.2-.6-.2-1-.2-.3 0-.6.2-.9.4s-.5.5-.6.9c-.1.3-.1.7 0 1l3.4 9.7-3.3 9.7c-.1.3-.1.7 0 1s.3.6.5.9c.3.2.6.4.9.4s.7 0 1-.2l18-10.3c.3-.1.5-.4.6-.6.2-.3.2-.6.2-.9s-.1-.6-.2-.9c-.2-.3-.4-.5-.6-.6zm-.8 1.5 18 10.3-18 10.3 3.2-9.4h7.1v-1.7h-7.1z" fill="currentColor" fillRule="evenodd"/></svg>);
});

IconLlmSend.displayName = 'IconLlmSend';
